module.exports = __webpack_public_path__ + "static/img/no-data.a0d19bce.png";